import { Component, Input } from '@angular/core';
import { FileTypeConstants } from '../../../../shared/constants/file-upload-type-constants';

@Component({
  selector: 'tow-reimbursement-info',
  templateUrl: './tow-reimbursement-info.component.html'
})
export class TowReimbursementInfoComponent {
  @Input() showInputLabels: boolean = true;

  public formCompleted: boolean = false;
  public acceptedFiles: string[] = [FileTypeConstants.txt, FileTypeConstants.doc, FileTypeConstants.docx, FileTypeConstants.pdf, FileTypeConstants.jpeg, FileTypeConstants.jpg, FileTypeConstants.png, FileTypeConstants.PNG, FileTypeConstants.gif];
  public importFiles: File[] = [];
  public missingUpload: boolean = false;

  constructor() { }

  public addImportFiles(filesToImport: File[]) {
    this.importFiles = filesToImport;
    this.missingUpload = false;
  }

  public removeFile(): void {
    this.importFiles = [];
    this.missingUpload = true;
  }

  //** Validates the form and sets formCompleted to valid or invalid */
  public validateForm(): void {
    this.missingUpload = this.importFiles.length === 0;
    this.formCompleted = !this.missingUpload;
  }
}
